import Vue from "vue";
import OwnOrganizationSpeechBubble from "./index.vue";
import { RecruitmentEventTypes } from "@/api/types";
import {
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
} from "./types";

export default Vue.extend<
  ContainerData,
  ContainerMethods,
  ContainerComputed,
  ContainerProps
>({
  computed: {
    selectedEvent() {
      return this.$store.getters["pages/plan/getSelectedRecruitmentEvent"];
    },
    formattedSelectedEvent() {
      if (!this.selectedEvent) {
        return;
      }

      const selectedEventType = RecruitmentEventTypes.find(
        eventType => eventType.value === this.selectedEvent!.event_type // TODO: なぜか!が必要
      );
      return {
        eventType: selectedEventType ? selectedEventType.label : "",
        title: this.selectedEvent.name,
        fromDate: this.selectedEvent.startDate.toDate(),
        toDate: this.selectedEvent.endDate.toDate(),
        note: this.selectedEvent.description
      };
    },
    speechBubble() {
      return this.$store.state.pages.plan.speechBubble;
    }
  },
  methods: {
    handleClickEditEventViewOpen() {
      this.$store.commit("pages/plan/updateEditEventView", {
        isVisible: true
      });
    },
    initSelectedEvent() {
      this.$store.commit("pages/plan/updateSelectedEvent", {
        event: undefined
      });
    }
  },
  render(createElement) {
    return createElement(OwnOrganizationSpeechBubble, {
      props: {
        ...this.formattedSelectedEvent,
        speechBubble: this.speechBubble
      },
      on: {
        clickEditEventViewOpen: this.handleClickEditEventViewOpen,
        clickOwnOrganizationSpeechBubbleClose: this.initSelectedEvent
      }
    });
  }
});
